import React from "react"
import PropTypes from "prop-types"
import { Typography, Box } from "@mui/material"

import { formatChartNumber } from "./utils/numberFormat"
import { COLORS } from "./constants/colors"
import { overviewCardValueSx, overviewCardHelperTextSx } from "./OverviewCard"
import OverviewMetricIcon, {
  OVERVIEW_METRIC_ICON_PRESETS,
} from "./OverviewMetricIcon"

const EvolutionGapCard = ({ iconPreset, title, helper, amount, currency }) => {
  const iconConfig = OVERVIEW_METRIC_ICON_PRESETS[iconPreset]
  const palette = COLORS[iconConfig.accent] ?? COLORS.default

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1.5,
        p: 1.5,
        borderRadius: 2,
        backgroundColor: palette.background,
      }}
    >
      <OverviewMetricIcon
        Icon={iconConfig.Icon}
        accent={iconConfig.accent}
        size={40}
        iconSize={22}
      />
      <Box sx={{ flex: 1, minWidth: 0 }}>
        <Typography
          sx={{
            fontWeight: 600,
            fontSize: 14,
            lineHeight: 1.3,
            color: palette.color,
          }}
        >
          {title}
        </Typography>
        <Typography
          variant="body2"
          sx={{ ...overviewCardHelperTextSx, mt: 0.5, color: "#6b7280" }}
        >
          {helper}
        </Typography>
      </Box>
      <Typography
        sx={{
          ...overviewCardValueSx,
          fontSize: 22,
          flexShrink: 0,
          textAlign: "right",
          color: COLORS.text,
        }}
      >
        {formatChartNumber(amount, 2)} {currency}
      </Typography>
    </Box>
  )
}

EvolutionGapCard.propTypes = {
  iconPreset: PropTypes.oneOf(Object.keys(OVERVIEW_METRIC_ICON_PRESETS))
    .isRequired,
  title: PropTypes.string.isRequired,
  helper: PropTypes.string.isRequired,
  amount: PropTypes.number.isRequired,
  currency: PropTypes.string,
}

EvolutionGapCard.defaultProps = {
  currency: "",
}

export default EvolutionGapCard
